<template>
  <pagination
    :prev="prev"
    :next="next"
    @next="setCurrentPage(nextPage)"
    @prev="setCurrentPage(prevPage)"
  />
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { SET_CURRENT_PAGE } from '@/store/mutation-types'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination
  },
  computed: {
    ...mapGetters(['nextPage', 'prevPage']),
    ...mapState({ currentPage: state => state.projects.currentPage }),
    next () {
      return this.nextPage !== false ? this.$t('nextPage') : ''
    },
    prev () {
      return this.prevPage !== false ? this.$t('previousPage') : ''
    }
  },
  watch: {
    currentPage () {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, page: this.currentPage }
      })
    }
  },
  created () {
    const { query = {} } = this.$route
    query.page && this.setCurrentPage(0)
  },
  methods: {
    ...mapMutations({ setCurrentPage: SET_CURRENT_PAGE })
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/ProjectsPaginationContainer.vue